module.exports = __webpack_public_path__ + "img/remove.7770b668.png";